import Table from "@/ui/components/Table"
import type { ICompanyBank } from "@/types/company/IFullCompanyDto"
import Button from "@/ui/components/Button"
import Skeleton from "@/ui/components/Skeleton"

import { BalanceBanksItem } from "./Item"

import { useState, type FC } from "react"

import style from "../../style.module.scss"

type Props = {
  banks: ICompanyBank[]
  isLoading: boolean
}

const tableColumns: string[] = ["Название", "SWIFT", "ID", "Номер аккаунта", "Валюта", "Остаток"]

export const BalanceBanks: FC<Props> = ({ banks, isLoading }) => {
  const [isShowAll, setShowAll] = useState(false)

  const toggleShowAll = () => {
    setShowAll(!isShowAll)
  }

  return (
    <Table.Wrapper title="Все счета">
      <Table.Header className={style.banksTableRow} columns={tableColumns} />
      {isLoading ? (
        <Skeleton rows={4} />
      ) : (
        <>
          <div>
            {banks.length > 0 ? (
              banks.map((bank, idx) => {
                if (!isShowAll && idx > 1) {
                  return null
                }

                return <BalanceBanksItem item={bank} key={bank.id} index={idx} />
              })
            ) : (
              <Table.EmptyRow />
            )}
          </div>
          <div className={style.banksTableShowAllButton}>
            <Button onClick={toggleShowAll} variant="black">
              {isShowAll ? "Скрыть" : "Показать все"}
            </Button>
          </div>
        </>
      )}
    </Table.Wrapper>
  )
}
